import { k } from '../../localization/t';
import { getClass } from './classes';
import { maxForesight } from './oracle';
import { displayRushMax, maxFerocity } from './battlemage';

// Every class's meta currencies through one door. The header's class
// button lists whatever the player's class tracks; a class adds itself
// here and nowhere else. Each entry: { key, label, value, max? }. `max`
// draws a vial; without one the count stands alone. Values read off the
// profile's per-class blob (`profile.oracle`, `profile.battlemage`, ...),
// which the server owns; a class not yet settled server-side reads zero.
const BY_CLASS = {
  oracle: (profile, skills) => [
    { key: 'foresight', label: k('Foresight'), value: profile?.oracle?.foresight || 0, max: maxForesight(skills) },
  ],
  battlemage: (profile, skills) => {
    const rushMax = displayRushMax(skills);
    const ferocityMax = maxFerocity(skills);
    return [
      { key: 'rush', label: k('Rush of Battle'), value: profile?.battlemage?.rush || 0, ...(rushMax == null ? {} : { max: rushMax }) },
      ...(ferocityMax > 0 ? [{ key: 'ferocity', label: k('Ferocity'), value: profile?.battlemage?.ferocity || 0, max: ferocityMax }] : []),
    ];
  },
  wildheart: (profile) => [
    { key: 'fangs', label: k('Fangs'), value: profile?.wildheart?.fangs || 0 },
    { key: 'insignias', label: k('Insignias'), value: profile?.wildheart?.insignias || 0 },
    { key: 'essences', label: k('Essences'), value: profile?.wildheart?.essences || 0 },
  ],
  alchemist: (profile) => [
    { key: 'pituita', label: k('Pituita'), value: profile?.alchemist?.pituita || 0 },
    { key: 'sanguis', label: k('Sanguis'), value: profile?.alchemist?.sanguis || 0 },
    { key: 'melancholia', label: k('Melancholia'), value: profile?.alchemist?.melancholia || 0 },
    { key: 'cholera', label: k('Cholera'), value: profile?.alchemist?.cholera || 0 },
  ],
  // The satchel waiting for the next set-out; a running expedition's
  // wallet lives on the realm screen.
  realmwalker: (profile) => [
    { key: 'provisions', label: k('Provisions'), value: profile?.realmwalker?.satchel?.provisions || 0 },
    { key: 'coin', label: k('Coin'), value: profile?.realmwalker?.satchel?.coin || 0 },
  ],
};

// The player's class and its currencies, or null when no class is held
// (or the class tracks nothing, like the Mimic for now).
export function classCurrencies(profile) {
  const skills = profile?.skills;
  const cls = getClass(skills?.classKey);
  const build = cls && BY_CLASS[cls.key];
  if (!build) return null;
  return { cls, currencies: build(profile, skills) };
}
